import React from 'react';

const VoteContext = React.createContext();

export default VoteContext;